import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import { getFlowStatus } from '.'

function setFlowStatus(ac: ActionCard) {
  const { flow } = getFlowStatus(ac)

  ac.actionCardFlow = flow
}

export default setFlowStatus
